enum Routes {
  About = '/about',
  Experience = '/experience',
  MyApplication = '/my-application',
  Projects = '/projects',
  ViewProject = '/view-project',
  AddProject = '/add-project',
  EditProject = '/edit-project',
  AddEducation = '/add-education',
  EditEducation = '/edit-education',
  Profile = '/profile',
  Developers = '/developers',
  TermsOfUse = 'https://lemon.io/terms-of-use/',
  PrivacyPolicy = 'https://lemon.io/privacy-policy/',
  WelcomeQ = '/welcome/q',
  WelcomeD = '/welcome/d',
  EscapeTheMatrix = '/escape-the-matrix',
}

export default Routes;
